import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const PagesStudioPage = lazy(() => import('./pages/PagesStudioPage'));

export const EditorRoutes: RouteObject = {
  path: 'pages',
  children: [
    { path: '', element: <PagesStudioPage />, handle: { crumb: 'Pages & Visual Studio' } },
  ],
};
